import script from "./AudienceSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./AudienceSwitcher.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__